module.exports = __webpack_public_path__ + "img/mic-off.5b4ef72d.svg";